import Image from "next/image";

const IndustrialCapex = ({ data }) => {
  return (
    <section className="py-sp-100 sm:py-sp-big">
      <div className="container px-3">
        <div className="flex sm:flex-col flex-row md:gap-1">
          <div className="sm:w-full w-1/2 relative min-h-[290px]">
            <Image
              src={data?.capexBg}
              alt="capex background"
              fill
              className="absolute"
            />

            {/* Content */}
            <div className="relative z-1 h-full flex flex-col items-center justify-center text-center px-6 py-8">
              <h2
                className="text-heading sm:text-xl font-medium"
                dangerouslySetInnerHTML={{ __html: data?.heading }}
              />

              <div className="mt-4">
                <Image
                  src={data?.imageClock}
                  alt="clock"
                  width={140}
                  height={140}
                  className="object-contain"
                />
              </div>
            </div>
          </div>

          {/* RIGHT CARDS */}
          <div className="sm:w-full w-1/2 flex sm:gap-1 md:gap-1">
            {data?.Industrial?.map((item) => (
              <div
                key={item.id}
                className="w-1/3 rounded-xl overflow-hidden"
              >
                <div className="relative h-[330px] sm:h-[200px] sm:rounded-md">
                  <Image
                    src={item.image}
                    alt={item.text}
                    fill
                    className="object-cover"
                  />
                  <div className="absolute bottom-0 left-0 w-full p-3 sm:p-2 mb-3 sm:mb-1">
                    <p className="text-base2 sm:text-xs text-baseBlack font-medium">
                      {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrialCapex;
